import { ParameterType } from '@/study-search/enums';

import { FilterDefinition } from './FilterDefinition';
import { DurationFilterOptionValue } from '@studyportals/search-filters/server-side';
import { FilterOptionInformation } from '@studyportals/search-filters';

class DurationFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.DURATION,
			[
				new FilterOptionInformation('1 year', DurationFilterOptionValue.ONE_YEAR, '1-year', '1 Year'),
				new FilterOptionInformation('Less than 2 years', DurationFilterOptionValue.LESS_THAN_TWO_YEARS, '', ''),
				new FilterOptionInformation('2 years', DurationFilterOptionValue.TWO_YEARS, '2-years', '2 Years'),
				new FilterOptionInformation('2½ years', DurationFilterOptionValue.TWO_AND_A_HALF_YEARS, '', ''),
				new FilterOptionInformation('3 years', DurationFilterOptionValue.THREE_YEARS, '3-years', '3 Years'),
				new FilterOptionInformation('3½ years', DurationFilterOptionValue.THREE_AND_A_HALF_YEARS, '', ''),
				new FilterOptionInformation('4 years', DurationFilterOptionValue.FOUR_YEARS, '4-years', '4 Years'),
				new FilterOptionInformation('More than 4 years', DurationFilterOptionValue.MORE_THAN_FOUR_YEARS, '', ''),
			],
			[
				DurationFilterOptionValue.ONE_YEAR,
				DurationFilterOptionValue.TWO_YEARS,
				DurationFilterOptionValue.THREE_YEARS,
				DurationFilterOptionValue.FOUR_YEARS,
			],
		);
	}
}

export default new DurationFilterDefinition();
